// Gemeinsame Bausteine der Sonstige-Seiten (Handoff Sonstige Kontakte §1/§2).
import type { CSSProperties } from 'react';
import { CircleNotch, type Icon } from '@phosphor-icons/react';
import { avatarFarbe, kontaktInitialen } from '../../../../lib/kontakte/sonstige';

/** Runder Avatar mit Verlauf; Farbe stabil aus der id. */
export function KontaktAvatar({ id, name, groesse }: { id: string; name: string; groesse: 38 | 42 | 46 | 68 }) {
  const f = avatarFarbe(id);
  const gross = groesse === 68;
  const stil: CSSProperties = {
    width: groesse, height: groesse, borderRadius: '50%', flexShrink: 0,
    fontSize: gross ? 22 : groesse === 46 ? 15 : groesse === 42 ? 14 : 13, fontWeight: 800,
    color: 'var(--sk-av-ink)', background: f.verlauf,
    boxShadow: gross
      ? `inset 0 2px 0 rgba(255,255,255,0.45), inset 0 -4px 8px rgba(0,0,0,0.18), 0 14px 26px -10px ${f.farbe}`
      : groesse === 46
        ? `inset 0 1.5px 0 rgba(255,255,255,0.45), inset 0 -3px 6px rgba(0,0,0,0.15), 0 8px 16px -8px ${f.farbe}`
        : `inset 0 1.5px 0 rgba(255,255,255,0.45), 0 6px 12px -6px ${f.farbe}`,
  };
  return <span aria-hidden className="flex items-center justify-center" style={stil}>{kontaktInitialen(name)}</span>;
}

/** Chip „Sonstige“ (violett). */
export function SonstigeChip() {
  return (
    <span className="inline-flex shrink-0 items-center" style={{ height: 20, padding: '0 8px', borderRadius: 10, gap: 5, fontSize: 10.5, fontWeight: 800, background: 'var(--vio-soft)', color: 'var(--vio)' }}>
      <span aria-hidden style={{ width: 6, height: 6, borderRadius: '50%', background: 'var(--vio)' }} />
      Sonstige
    </span>
  );
}

/** Leerer Zustand eines Tabs (Glas-Karte, Duotone-Icon, Text wie bisher). */
export function LeerKarte({ icon: I, text }: { icon: Icon; text: string }) {
  return (
    <div role="status" className="sk-glas sk-rise flex flex-col items-center text-center" style={{ borderRadius: 26, padding: '44px 20px', gap: 10 }}>
      <I aria-hidden weight="duotone" size={30} color="var(--ink3)" />
      <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--ink3)' }}>{text}</span>
    </div>
  );
}

/** Lade-Anzeige eines Tabs. */
export function TabLaedt() {
  return (
    <div role="status" aria-label="Wird geladen" className="flex items-center justify-center" style={{ padding: 40 }}>
      <CircleNotch weight="bold" size={22} className="animate-spin" color="var(--acc)" />
    </div>
  );
}

/** Verlaufs-Icon in Palettenfarbe (Verknüpft, Aktivität, Schnell loggen). */
export function FarbIcon({ icon: I, farbe, groesse, radius, iconGroesse }: { icon: Icon; farbe: number; groesse: number; radius: number; iconGroesse: number }) {
  return (
    <span aria-hidden className="flex shrink-0 items-center justify-center"
      style={{ width: groesse, height: groesse, borderRadius: radius, color: 'var(--sk-av-ink)', background: `linear-gradient(155deg, var(--sk-av-${farbe}-a), var(--sk-av-${farbe}-b))`, boxShadow: `inset 0 1px 0 rgba(255,255,255,0.4), 0 8px 14px -8px var(--sk-av-${farbe}-b)` }}>
      <I weight="fill" size={iconGroesse} />
    </span>
  );
}
